import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import logo from "../../components/media/cegoslogo.webp";
import userFallback from "../../components/media/userFallBackLogo.png";

function Navbar({ user, logOutGoogleUser, userPhoto }) {
  const [userPopUp, setUserPopUp] = useState(false);
  const [imgSrc, setImgSrc] = useState(userPhoto || userFallback);
  
  useEffect(() => {
    setImgSrc(userPhoto || userFallback);
  }, [userPhoto]);

  const handleUserPopUp = () => {
    setUserPopUp(!userPopUp);
  };

  const handleImageError = () => {
   
    if (imgSrc !== userFallback) {
      setImgSrc(userFallback);
    }
  };

  return (
    <nav className="flex justify-between items-center py-4 px-8 bg-white shadow-lg border-b-2 rounded-lg">
      <Link to="/home">
        <img src={logo} alt="logo" className="h-20 w-full" />
      </Link>
      <div className="flex space-x-4 text-lg font-bold items-center">
        {user && (
          <>
            {userPopUp && (
              <div className="absolute top-20 right-8 bg-white shadow-md p-4 rounded w-50 z-10 border border-gray-200">
                <div className="flex flex-col space-y-2">
                  <div className="flex space-x-4 border-b-2 pb-2 border-black">
                    <p className="text-lg font-bold">
                      Welcome{" "}
                      <span className="text-orange-500">
                        {user}
                      </span>
                    </p>
                  </div>

                  <Link to={`/getduplicatesleads`} target="_blank">
                    <button 
                      onClick={() => setUserPopUp(false)}
                      className="px-6 py-2 bg-gradient-to-r from-purple-800 to-blue-900 w-full text-white rounded-lg text-lg hover:shadow-lg"
                    >
                      Duplicates Copper
                    </button>
                  </Link>
                  <button
                    onClick={logOutGoogleUser}
                    className="bg-red-500 hover:bg-red-700 text-lg text-white font-bold px-6 py-2 rounded-lg hover:shadow-lg"
                  >
                    Sign Out
                  </button>
                </div>
              </div>
            )}

            <div className="relative">
              <img
                onClick={handleUserPopUp}
                src={imgSrc}
                onError={handleImageError}
                alt="User profile"
                className="h-10 w-10 rounded-full hover:shadow-xl cursor-pointer object-cover"
              />
            </div>
          </>
        )}
      </div>
    </nav>
  );
}

export default Navbar;